<template>
  <div class="locationsearch rfp-storelocator-tcell">
    <div class="storelocater-col-md-12 storelocater-col-sm-12">
      <div class="rfp-store-locator-row">
        <div class="storelocater-col-sm-6">
          <label for="txtZIPCODE" class="locationsearch-label">{{ title }}</label>
          <input
            id="txtZIPCODE"
            v-model="postalcode"
            type="text"
            class="storelocator__input input--text zipcode"
            :placeholder="placeholderZipCode"
            :name="title"
            :title="title"
            :aria-invalid="!!invalidMessage"
            :aria-describedby="getErrorFieldId()"
            autocomplete="postal-code"
            style="display: block"
          />
          <p :id="getErrorFieldId()" class="field-error">{{ invalidMessage }}</p>
        </div>
        <div v-if="filterByDistanceEnable" class="storelocater-col-sm-6">
          <label for="distanceSelectionFilter" class="locationsearch-label"
            >{{ labelFilterByDistance }}
          </label>
          <select
            id="distanceSelectionFilter"
            v-model="filterByDistanceModel"
            class="storelocator__input input--text storelocater------select"
            @change="process($event, 'distance')"
          >
            <option v-for="(item, index) in DistanceModel.datas" :key="index" :value="item.Key">
              {{ item.Value }}
            </option>
          </select>
        </div>
        <div v-if="filterByTypeEnable && !iriEnabled" class="storelocater-col-sm-6">
          <label for="typeSelectionFilter" class="locationsearch-label"
            >{{ labelFilterByType }}
          </label>
          <select
            id="typeSelectionFilter"
            v-model="filterByTypeModel"
            class="storelocator__input input--text storelocater------select"
            @change="process($event, 'type')"
          >
            <option v-for="(item, i) in typeModelData.datas" :key="i" :value="item.Key">
              {{ item.Value }}
            </option>
          </select>
        </div>
        <div v-if="isFilterByProductGroupEnable && iriEnabled" class="storelocater-col-sm-6">
          <label for="productGroupFilter" class="locationsearch-label"
            >{{ labelFilterByProductGroup }}
          </label>
          <select
            id="productGroupFilter"
            v-model="filterByProductGroupModel"
            class="storelocator__input input--text storelocater------select"
            @change="process($event, 'product-group')"
          >
            <option v-if="productGroupFilterUsePlaceholderText" value="" disabled selected hidden>
              {{ placeholderFilterByProductGroup }}
            </option>
            <option v-for="(item, i) in productGroupModelData.datas" :key="i" :value="item.Key">
              {{ item.Value }}
            </option>
          </select>
          <span class="field-error">{{ productGroupInvalidMessage }}</span>
        </div>
        <template v-if="!iriEnabled">
          <template v-for="(storeAttributeFilter, attributeIndex) in storeAttributeFilters">
            <div
              v-if="storeAttributeFilter.FilterOptions"
              :key="attributeIndex"
              class="storelocater-col-sm-6"
            >
              <label :for="storeAttributeFilters[attributeIndex].Id" class="locationsearch-label"
                >{{ storeAttributeFilter.Name }}
              </label>
              <select
                :id="storeAttributeFilters[attributeIndex].Id"
                v-model="filterByAttribute[storeAttributeFilter.Id]"
                class="storelocator__input input--text storelocater------select"
                @change="process($event, 'store-attribute', storeAttributeFilter.Id)"
              >
                <option value="">{{ labelFilterAllOptions }}</option>
                <option
                  v-for="(item, index) in storeAttributeFilter.FilterOptions"
                  :key="index"
                  :value="index"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          </template>
        </template>
        <div class="storelocater-col-sm-6 store-btn">
          <button
            type="submit"
            :title="btnSearch"
            value="search"
            class="location-btn"
            @click="getPosition(1)"
          >
            {{ btnSearch }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * HACK:
 * This empty script is required to make nested components work in Vue 3
 * while keeping compatibility with Vue 2 intact.
 */
</script>

<script>
import eventBus from '@refapp/eventbus-js';
import { tryParseJson } from '../mixins/utils';

/* global google */

/**
 * @module Component/LocationSearch
 * @desc the LocationSearch tag implement
 */

export default {
  /**
   * @member {type} name tag name of the component
   * @readonly
   */
  name: 'rfp-storelocator-location-search',
  props: {
    /**
     * @member {string} btnSearch
     * @desc search button value
     */
    btnSearch: {
      type: String,
      required: true,
    },
    /**
     * @member {string} placeholder
     * @desc placeholder of input
     */
    placeholders: {
      type: String,
      required: true,
    },
    /**
     * @member {string} title
     * @desc title of the page
     */
    title: {
      type: String,
      required: true,
    },
    labelFilterByType: {
      type: String,
      required: true,
    },
    labelFilterByProductGroup: {
      type: String,
      required: true,
    },
    placeholderFilterByProductGroup: {
      type: String,
      required: true,
    },
    placeholderFilterByType: {
      type: String,
      required: true,
    },
    placeholderFilterByDistance: {
      type: String,
      required: true,
    },
    distanceType: {
      type: String,
      required: true,
      default: '',
    },
    labelFilterByDistance: {
      type: String,
      required: true,
    },
    filterByTypeDatas: {
      type: String,
      required: true,
    },
    filterByProductGroupDatas: {
      type: String,
      required: true,
    },
    filterByDistanceDatas: {
      type: String,
      required: true,
    },
    filterByDistanceEnable: {
      type: Boolean,
      required: true,
    },
    filterByTypeEnable: {
      type: Boolean,
      required: true,
    },
    filterByProductGroupEnable: {
      type: Boolean,
      required: true,
    },
    productGroupFilterUsePlaceholderText: {
      type: Boolean,
      required: true,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
    productGroupErrorMessage: {
      type: String,
      required: false,
      default: '',
    },
    rfpTaggingFindStore: {
      type: String,
      required: false,
      default: '',
    },
    iriEnabled: {
      type: Boolean,
      default: true,
    },
    placeholderZipCode: {
      type: String,
      default: 'Please enter Zipcode',
    },
    upc: {
      type: String,
      required: false,
      default: '',
    },
    zipcodeRequired: {
      type: String,
      required: true,
    },
    defaultRadius: {
      type: String,
      required: true,
    },
    defaultDistanceMetric: {
      type: String,
      required: true,
    },
    defaultCountry: {
      type: String,
      required: true,
    },
    storeAttributeFilters: {
      type: Array,
      required: false,
      default: () => [],
    },
    labelFilterAllOptions: {
      type: String,
      required: false,
      default: '',
    },
    filterPresets: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  /**
   * @function data
   * @desc init the data when the component mount
   */
  data() {
    let productGroups = tryParseJson(this.filterByProductGroupDatas);
    let filterPresetAlias = this.getParameter('filter');
    let filterPreset = null;
    if (filterPresetAlias != '' && this.filterPresets != null && this.filterPresets.length) {
      filterPreset = this.filterPresets.find(
        (preset) => preset.Alias.toLowerCase() === filterPresetAlias.toLowerCase(),
      );
    }

    return {
      invalidMessage: '',
      productGroupInvalidMessage: '',
      postalcode: '',
      typeModelData: tryParseJson(this.filterByTypeDatas),
      productGroupModelData: productGroups,
      DistanceModel: tryParseJson(this.filterByDistanceDatas),
      filterByTypeModel: this.getInitialFilterByTypeModelValue(filterPreset),
      filterByProductGroupModel:
        !this.productGroupFilterUsePlaceholderText && productGroups.datas.length > 0
          ? productGroups.datas[0].Key
          : '',
      filterByDistanceModel: this.getInitialFilterByDistanceModelValue(filterPreset),
      searchDataLayer: '',
      filterByAttribute: this.getInitialFilterByAttributesModel(filterPreset),
      isFilterByProductGroupEnable: this.filterByProductGroupEnable,
    };
  },
  /**
   * @function created
   * @desc on mounting,initiate the function
   */
  created() {
    eventBus.on('rfp-after-loaded-page', () => {
      const latLng = {
        distanceTypes: this.filterByDistanceEnable ? this.distanceType : this.defaultDistanceMetric,
        distanceEnabled: this.filterByDistanceEnable,
        filterByAttribute: this.filterByAttribute,
        productGroupId: this.filterByProductGroupModel,
        productGroupEnabled: this.isFilterByProductGroupEnable,
        distances: this.filterByDistanceModel,
        typemodel: this.filterByTypeModel,
      };

      eventBus.emit('presetFilters', latLng);
    });
    eventBus.on('invalidMsg', () => {
      this.invalidMessage = '';
    });
    eventBus.on('postalCode', (value) => {
      this.postalcode = value;
    });
    eventBus.emit('enablePdp');
    eventBus.on('pageNavigationNextPrev', (value) => {
      this.getPosition(value);
    });

    // Disable product group filter in case if UPC url param is available
    if (this.isFilterByProductGroupEnable && this.getParameter(this.upc) != '') {
      this.isFilterByProductGroupEnable = false;
    }
  },
  mounted() {
    document.querySelector('.storelocator.storelocator--background').removeAttribute('style');
  },
  methods: {
    isSearchFormValid() {
      this.productGroupInvalidMessage = '';
      this.invalidMessage = '';
      if (
        this.iriEnabled &&
        this.isFilterByProductGroupEnable &&
        this.filterByProductGroupModel == ''
      ) {
        this.productGroupInvalidMessage = this.productGroupErrorMessage;
      }

      if (this.postalcode === '' || this.postalcode === undefined) {
        if (this.iriEnabled) {
          this.invalidMessage = this.zipcodeRequired;
        } else {
          this.invalidMessage = this.errorMessage;
        }
      }

      return this.productGroupInvalidMessage === '' && this.invalidMessage === '';
    },
    /**
     * @function getPosition
     * @desc on getPosition get the lat and lon from user given address.
     */
    getPosition(pageNo) {
      eventBus.emit('updateGoogleMapDatas', false);
      if (this.iriEnabled && document.getElementById('txtZIPCODE') === null) {
        document.getElementById('txtZIPCODE').style.display = 'block';
      } else {
        this.postalcode = document.getElementById('txtZIPCODE').value;
      }

      eventBus.emit('defaultDistanceEmpty');

      if (!window.google) {
        console.warn('google map api are not working............................');
        return;
      }

      if (!this.isSearchFormValid()) {
        return;
      }

      const zipValue = this.postalcode;
      const geocoder = new google.maps.Geocoder();
      const zipCode = this.postalcode.replace(/[\s|-]?/g, '');
      let countryCode =
        this.defaultCountry && this.defaultCountry.length > 0
          ? this.defaultCountry.split(',')[0]
          : '';
      let geocodeFilters = { address: zipValue, region: countryCode };
      if (!isNaN(zipCode) && zipCode.length < 7) {
        geocodeFilters = { componentRestrictions: { postalCode: zipCode, country: countryCode } };
      }

      geocoder.geocode(geocodeFilters, (results, status) => {
        const isQueryLimitExceeded = status === 'OVER_QUERY_LIMIT';
        if (status === google.maps.GeocoderStatus.OK || isQueryLimitExceeded) {
          if (!isQueryLimitExceeded) {
            eventBus.emit('storeMsg');
            eventBus.emit('postalCode', zipValue);
            const lat = results[0].geometry.location.lat();
            const lng = results[0].geometry.location.lng();
            const latLng = {
              lat: lat,
              lon: lng,
              typemodel: this.filterByTypeModel,
              productGroupId: this.filterByProductGroupModel,
              distances: this.filterByDistanceEnable
                ? this.filterByDistanceModel
                  ? this.filterByDistanceModel
                  : this.defaultRadius
                : this.defaultRadius,
              distanceTypes: this.filterByDistanceEnable
                ? this.distanceType
                : this.defaultDistanceMetric,
              distanceEnabled: this.filterByDistanceEnable,
              categoryEnabled: this.filterByTypeEnable,
              productGroupEnabled: this.isFilterByProductGroupEnable,
              zip: this.postalcode,
              upc: this.upc,
              pageNo: pageNo,
              filterByAttribute: this.filterByAttribute,
            };
            eventBus.emit('promotionMapDataClose');
            eventBus.emit('mapData', latLng);

            const handleStoresFound = () => {
              this.gtmDatalayers();
              eventBus.off('rfp-stores-found', handleStoresFound);
            };

            eventBus.on('rfp-stores-found', handleStoresFound);
          }
        } else {
          if (this.iriEnabled) {
            this.invalidMessage = this.zipcodeRequired;
          } else {
            this.invalidMessage = this.errorMessage;
          }
        }
      });
    },
    gtmDatalayers() {
      if (this.postalcode != '') {
        const obj = {};
        if (this.rfpTaggingFindStore != '' && this.rfpTaggingFindStore != 'null') {
          const objData = tryParseJson(this.rfpTaggingFindStore);
          for (const [key, value] of Object.entries(objData)) {
            obj[key] = value;

            // todo: this should ideally be funneled through the datalayer-mixin
            if (['[zipcode or city]', this.searchDataLayer].includes(value)) {
              this.searchDataLayer = this.postalcode;
              obj[key] = this.postalcode.toLowerCase();
            }
          }
        }

        if (window.dataLayer !== undefined) {
          window.dataLayer.push(obj);
        }
      }
    },
    process($event, filterType, filterId) {
      this.postalcode = document.getElementById('txtZIPCODE').value;
      switch (filterType) {
        case 'distance':
          this.filterByDistanceModel = $event.target.value;
          break;
        case 'type':
          this.filterByTypeModel = $event.target.value;
          break;
        case 'product-group':
          this.filterByProductGroupModel = $event.target.value;
          break;
        case 'store-attribute':
          this.filterByAttribute[filterId] = $event.target.value;
          break;
      }
    },
    getParameter(paramName) {
      var searchString = window.location.search.substring(1),
        i,
        val,
        params = searchString.split('&');

      for (i = 0; i < params.length; i++) {
        val = params[i].split('=');
        if (val[0] == paramName) {
          return val[1];
        }
      }
      return '';
    },
    getInitialFilterByAttributesModel(filterPreset) {
      let filterByAttributesModels = [];
      this.storeAttributeFilters.forEach((item) => {
        if (filterPreset && filterPreset.Attributes[item.Id]) {
          filterByAttributesModels[item.Id] = filterPreset.Attributes[item.Id];
        } else {
          filterByAttributesModels[item.Id] = '';
        }
      });

      return filterByAttributesModels;
    },
    getInitialFilterByTypeModelValue(filterPreset) {
      let filterByTypeDatasParsed = tryParseJson(this.filterByTypeDatas);
      if (
        !filterByTypeDatasParsed ||
        !filterByTypeDatasParsed.datas ||
        !filterByTypeDatasParsed.datas[0]
      ) {
        return '';
      }

      let filterByTypeModelValue = filterByTypeDatasParsed.datas[0].Key;
      if (filterPreset && filterPreset.Category && filterPreset.Category.length) {
        let categoryFilterOption = filterByTypeDatasParsed.datas.find(
          (f) => f.Key.toLowerCase() === filterPreset.Category.toLowerCase(),
        );
        if (categoryFilterOption && categoryFilterOption.Key) {
          filterByTypeModelValue = categoryFilterOption.Key;
        }
      }

      return filterByTypeModelValue;
    },
    getInitialFilterByDistanceModelValue(filterPreset) {
      let filterByDistanceDatasParsed = tryParseJson(this.filterByDistanceDatas);
      if (
        !this.filterByDistanceEnable ||
        !filterByDistanceDatasParsed ||
        !filterByDistanceDatasParsed.datas ||
        !filterByDistanceDatasParsed.datas[0]
      ) {
        return '';
      }

      let filterByDistanceModelValue = filterByDistanceDatasParsed.datas[0].Key;
      if (filterPreset && filterPreset.Distance && filterPreset.Distance.length) {
        let distanceFilterOption = filterByDistanceDatasParsed.datas.find(
          (f) => f.Key.toLowerCase() === filterPreset.Distance.toLowerCase(),
        );
        if (distanceFilterOption && distanceFilterOption.Key) {
          filterByDistanceModelValue = distanceFilterOption.Key;
        }
      }

      return filterByDistanceModelValue;
    },
    getErrorFieldId() {
      return this.invalidMessage ? 'storelocator__zipcode-field-error' : null;
    },
  },
};
</script>
